import { createContext, useContext, useMemo } from "react";
import type { Reaction } from "./useCallUiState";

/**
 * Carries the live reactions queue down to whichever tile component renders
 * the matching participant (mirrors `useLocalCameraAffordance`'s rationale) —
 * tiles are rendered deep inside GridLayout / SpeakerLayout / SidebarLayout,
 * not from InCallView props, so a context keeps the per-tile reaction badge
 * out of the layout components entirely.
 */
const ReactionsContext = createContext<Reaction[]>([]);

export const ReactionsProvider = ReactionsContext.Provider;

/** Latest active reaction for a given participant identity, or null. */
export function useTileReaction(identity: string): Reaction | null {
  const reactions = useContext(ReactionsContext);
  return useMemo(() => {
    let latest: Reaction | null = null;
    for (const r of reactions) {
      if (r.senderIdentity === identity && (!latest || r.ts > latest.ts)) {
        latest = r;
      }
    }
    return latest;
  }, [reactions, identity]);
}
